// removed by extract-text-webpack-plugin
module.exports = {"hamburger":"HamburgerIcon__hamburger__3ywQG","top":"HamburgerIcon__top__IvKwJ","center":"HamburgerIcon__center__1ng6w","bottom":"HamburgerIcon__bottom___t9Wt","expanded":"HamburgerIcon__expanded__IGKZA"};


//////////////////
// WEBPACK FOOTER
// ./src/icons/HamburgerIcon.scss
// module id = 680
// module chunks = 0